import type React from "react";
import { Info } from "lucide-react";
import { i18n } from "@frontend/i18n";
import { cn } from "@planta-v2/pds-ui/lib/utils";

export interface LinkExpiredStateProps {
  readonly message?: string | undefined;

  readonly testId?: string | undefined;

  readonly className?: string | undefined;
}

export function LinkExpiredState({
  message,
  testId = "link-expired-state",
  className,
}: LinkExpiredStateProps): React.JSX.Element {
  const displayMessage = message ?? i18n.t("auth.otp.expired.message");

  return (
    <div
      className={cn(
        "flex flex-col items-center justify-center py-12 px-4",
        className,
      )}
      data-testid={testId}
    >
      <Info className="h-6 w-6 text-muted-foreground mb-2" />
      <h3 className="text-sm font-medium text-foreground mb-1">
        {i18n.t("auth.otp.expired.title")}
      </h3>
      <p className="text-xs text-muted-foreground text-center mb-4 whitespace-pre-line">
        {displayMessage}
      </p>
    </div>
  );
}
